"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TAFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_220)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_220`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.08203 0H28.9215V24H-7.08203V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.9197 0V8.25549H7.678L10.9197 10.4143V12.0035H9.33051L4.16907 8.5649V12.0035H-0.331372V8.5649L-5.49281 12.0035H-7.08203V10.4143L-3.84031 8.25549H-7.08203V3.75505H-3.84031L-7.08203 1.59625V0H-5.49281L-0.331372 3.43862V0H4.16907V3.43862L9.33051 0H10.9197Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.04396 0H0.793738V4.88016H-7.08203V7.13038H0.793738V12.0035H3.04396V7.13038H10.9197V4.88016H3.04396V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.08203 0V1.06182L-3.0457 3.75505H-1.45648L-7.08203 0ZM10.9197 0V1.06182L6.8834 3.75505H5.29418L10.9197 0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.9197 1.59619V3.755H7.67798L10.9197 1.59619Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.08203 0V1.06182L-3.0457 3.75505H-1.45648L-7.08203 0ZM10.9197 0V1.06182L6.8834 3.75505H5.29418L10.9197 0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.9197 1.59619V3.755H7.67798L10.9197 1.59619Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.08203 12.0035V10.9417L-3.0457 8.25549H-1.45648L-7.08203 12.0035ZM10.9197 12.0035V10.9417L6.8834 8.25549H5.29418L10.9197 12.0035Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M24.4843 11.9191C24.4843 12.5942 24.4632 14.0006 24.3859 14.6756C24.0976 17.1298 22.7334 19.5136 20.0191 20.7161C16.8336 19.4574 15.7436 17.1298 15.4553 14.6756C15.378 14.0006 15.3499 13.3114 15.3499 12.6364L15.3709 9.32434H24.4562L24.4843 11.9191Z",
					fill: "#29DBFF"
				}),
				/* @__PURE__ */ n("path", {
					d: "M24.3859 14.6757C24.3718 14.7882 24.3577 14.9077 24.3437 15.0202C24.0061 17.3478 22.7334 19.6191 20.019 20.7161C16.9812 19.5207 15.8421 17.3478 15.5045 15.0202C15.4905 14.9077 15.4764 14.7952 15.4623 14.6757",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.0191 17.6994L18.4088 14.6757H21.6294L20.0191 17.6994Z",
					fill: "#29DBFF"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.0191 11.6589L18.4088 14.6756H21.6294L20.0191 11.6589Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.6833 19.6965C14.3357 19.6965 14.8646 18.3333 14.8646 16.6516C14.8646 14.97 14.3357 13.6068 13.6833 13.6068C13.0308 13.6068 12.5019 14.97 12.5019 16.6516C12.5019 18.3333 13.0308 19.6965 13.6833 19.6965Z",
					fill: "#FFBE57"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.019 2.21509L17.6704 5.30914H22.4872L20.019 2.21509ZM15.1037 19.6894C15.1037 19.6894 17.4805 21.7639 20.019 21.7639C22.5575 21.7639 24.7374 19.6894 24.7374 19.6894L25.3352 20.7161C25.3352 20.7161 23.8022 22.9241 20.019 22.9241C16.2358 22.9241 14.506 20.7161 14.506 20.7161L15.1037 19.6894Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.0823 8.97281C21.4144 8.97281 22.4943 8.23925 22.4943 7.33436C22.4943 6.42948 21.4144 5.69592 20.0823 5.69592C18.7502 5.69592 17.6703 6.42948 17.6703 7.33436C17.6703 8.23925 18.7502 8.97281 20.0823 8.97281Z",
					fill: "#A5A5A5"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_220`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TAFlag };
